import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as MessageBannerActions from './message-banner.actions';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class MessageBannerStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new MessageBannerActions.GetAll());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.MESSAGEBANNER, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Update:
          this.store.dispatch(new MessageBannerActions.Update(data.obj));
          break;
        case SignalRAction.Get:
          this.store.dispatch(new MessageBannerActions.GetAll());
          break;
        case SignalRAction.Add:
          this.store.dispatch(new MessageBannerActions.Add(data.obj));
          break;
        case SignalRAction.Delete:
          this.store.dispatch(new MessageBannerActions.Delete(data.obj));
      }
    });
  }
}
